import Link, { LinkProps } from 'next/link';

interface Props {
  href: string;
  newTab?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  passHref?: boolean;
}

export default function LinkWrapper({
  children,
  href,
  newTab,
  disabled,
  passHref,
  ...props
}: Props) {
  if (disabled) return <div {...props}>{children}</div>;

  return (
    <Link
      href={href}
      passHref={passHref}
      {...props}
      target={newTab ? '_blank' : undefined}
    >
      {children}
    </Link>
  );
}
